import { Container, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";

import { getFirebaseRealTimeDatabase } from "../../services/firebaseRealTimeDatabase";
import { useStore } from "../../store";
import { ClientPlan } from "../../types";
import useStyles from "./styles";
import { Select } from "../../components/Select";
import { CardPlan } from "../../components/CardPlan";
import { CheckOutPlan } from "../../components/Modals/CheckOutPlan";
import {
  useCreateSubscriptionPlanConsumption,
  useGetAllPlans,
} from "../../api/plans/hooks";

export const Plans: React.FC = () => {
  const Styles = useStyles();

  const [entityId, setEntityId] = useState<string>("");
  const [plans, setPlans] = useState<any>([]);
  const [plansList, setPlansList] = useState<any[]>([]);
  const [selectedPlan, setSelectedPlan] = useState<ClientPlan[] | null>(null);
  const [planSelected, setPlanSelected] = useState("all");
  const [planId, setPlanId] = useState("all");

  const [openModal, setOpenModal] = useState<boolean>(true);

  const { userManager } = useStore();

  const {
    data: _plans,
    isLoading,
    refetch: reFetchPlans,
  } = useGetAllPlans(entityId, !!entityId);

  const { mutateAsync } = useCreateSubscriptionPlanConsumption();

  const handleOpenModal = (plan: ClientPlan[]) => {
    setSelectedPlan(plan);

    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);

    setSelectedPlan(null);
  };

  const filteredPlans = () => {
    if (planId === "all") return plans;

    return plans.filter((p: any) => p.id === planId);
  };

  const loadPlans = async () => {
    if (_plans) {
      console.log(_plans);
      const now = Date.now();
      const plansData = _plans.map((plan: any) => ({
        id: plan.id,
        name: plan.name,
        photo: plan.photo,
        subscriptions: plan.subscriptions
          .filter((subscription: any) => {
            if (subscription.removedAt) return !!subscription.accessEndsAt && Date.parse(subscription.accessEndsAt) > now;
            const nextChargeTs = subscription?.nextTimeToCharge
              ? Date.parse(subscription.nextTimeToCharge)
              : null;

            if (subscription.status === 1) {
              return true;
            }

            if (subscription.status === 3 && nextChargeTs) {
              return nextChargeTs > now;
            }

            return false;
          })
          .map((sub: any) => ({
            subscriptionId: sub.subscriptionId,
            planId: sub.planId,
            id: sub.client?.id,
            name: sub.client?.name || "",
            picture: sub.client?.picture || null,
            foodRestriction: sub.foodRestriction || "",
            identityNumber: sub.client?.identityNumber,
            status: sub.status,
            nextTimeToCharge: sub.nextTimeToCharge,
          })),
      }));

      setPlans(plansData);
    }
  };

  const formatList = () => {
    const listPlans = _plans?.map((plan: any) => ({
      label: plan.name,
      value: plan.id,
    }));

    const listSortedPlans: any[] = listPlans?.sort((a: any, b: any) =>
      a.label.localeCompare(b.label),);

    listSortedPlans.unshift({ label: "Todos", value: "all" });

    setPlansList(listSortedPlans);
  };

  const filterPlans = (id: string) => {
    setPlanSelected(id);
    setPlanId(id);
  };

  const submit = async (id: string) => {
    const response = await mutateAsync({
      subscriptionPlanId: id,
    });

    if (response) {
      handleCloseModal();
    }
  };

  useEffect(() => {
    getFirebaseRealTimeDatabase(userManager.entity, async () => {
      await reFetchPlans();
    });
  }, []);

  useEffect(() => {
    (async () => {
      await loadPlans();
    })();
  }, [_plans]);

  useEffect(() => {
    if (userManager.entity) {
      setEntityId(userManager.entity);
    }
  }, [userManager]);

  useEffect(() => {
    if (_plans?.length) {
      formatList();
    }
  }, [_plans]);

  return (
    <Container maxWidth={false} className={Styles.container}>
      <div className={Styles.table}>
        <div className={Styles.selectsWrapper}>
          {plansList?.length > 0 && (
            <div className={Styles.filterSector}>
              <Select
                label="Planos"
                options={plansList}
                value={planSelected}
                onChange={(val) => filterPlans(val)}
              />
            </div>
          )}
        </div>
        <hr className={Styles.line} />

        {isLoading && (
          <div className={Styles.tableBody}>
            <div className={Styles.tableRow}>
              <Typography
                noWrap
                className={`${Styles.tableCell} ${Styles.tableColumn2}`}
              >
                Loading data...
              </Typography>
            </div>
          </div>
        )}
        {!isLoading && (
          <div className={Styles.tableWrapper}>
            <div className={Styles.tableBody}>
              {filteredPlans().map((plan: any) => (
                <div key={plan.id}>
                  <CardPlan
                    name={plan.name}
                    key={plan.id}
                    photo={plan.photo}
                    selectPlan={() => handleOpenModal(plan.subscriptions)}
                  />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {selectedPlan && (
        <CheckOutPlan
          client={selectedPlan}
          open={openModal}
          onClose={handleCloseModal}
          handleSave={submit}
        />
      )}
    </Container>
  );
};
